import React from "react";

import useStyles from "./ScreenReaderOnly.style";

export const ScreenReaderOnly: React.FC<{ text: string; id?: string; startWithEmptySpace?: boolean; testId?: string; }> = ({
    text,
    id,
    startWithEmptySpace = true,
    testId = 'ScreenReaderOnly',
}) => {
  const c = useStyles({});
  const prepareTextValue = startWithEmptySpace ? ` ${text}` : text;
  return <span id={id} className={c.root} data-testid={testId}>{prepareTextValue}</span>;
};
